
// import React, { useState } from "react";
// import {
//   FaShoppingCart,
//   FaUser,
//   FaBars,
//   FaHeart,
// } from "react-icons/fa";
// import { GrSearch } from "react-icons/gr";
// import { Link, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import logo from "../assest/products/extra/logo.jpeg";
// import { logoutUser } from "../store/userSlice";

// const Header = () => {

//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   const cartCount = useSelector((state) => state.cart.cartCount);
//   const user = useSelector((state) => state.user.user);

//   const [menuOpen, setMenuOpen] = useState(false);
//   const [dropdown, setDropdown] = useState(false);
//   const [search, setSearch] = useState("");

//   const handleSearch = (e) => {
//     e.preventDefault();
//     navigate(`/search?q=${search}`);
//   };

//   const handleLogout = () => {
//     dispatch(logoutUser());
//     navigate("/login");
//   };

//   return (
//     <>
//       {/* 🔥 DESKTOP HEADER */}
//       <header className="hidden md:block w-full bg-white shadow-sm border-b fixed top-0 z-50">

//         <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

//           {/* LOGO */}
//           <Link to="/">
//             <img src={logo} alt="logo" className="h-10" />
//           </Link>

//           {/* SEARCH */}
//           <form
//             onSubmit={handleSearch}
//             className="flex items-center border-2 border-red-500 rounded-full overflow-hidden w-[500px]"
//           >
//             <input
//               type="text"
//               placeholder="Search products..."
//               className="flex-1 px-3 py-2 outline-none"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//             <button className="bg-red-500 text-white px-5 py-2">
//               <GrSearch />
//             </button>
//           </form>

//           {/* RIGHT */}
//           <div className="flex items-center gap-6 text-sm">

//             {/* 🔥 USER SECTION */}
//             {user ? (
//               <div className="relative">

//                 <div
//                   onClick={() => setDropdown(!dropdown)}
//                   className="flex flex-col items-center cursor-pointer"
//                 >
//                   <FaUser />
//                   <span className="capitalize">
//                     {user.name?.split(" ")[0]}
//                   </span>
//                 </div>

//                 {/* 🔥 DROPDOWN */}
//                 {dropdown && (
//                   <div className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-lg p-2 z-50">

//                     <Link to="/account/profile" className="block px-3 py-2 hover:bg-gray-100">
//                       My Account
//                     </Link>

//                     <Link to="/account/orders" className="block px-3 py-2 hover:bg-gray-100">
//                       Orders
//                     </Link>

//                     {/* 🔥 ADMIN */}
//                     {user.role === "ADMIN" && (
//                       <Link to="/admin-panel/dashboard" className="block px-3 py-2 text-blue-600 hover:bg-gray-100">
//                         Admin Panel
//                       </Link>
//                     )}

//                     <button
//                       onClick={handleLogout}
//                       className="w-full text-left px-3 py-2 hover:bg-gray-100 text-red-500"
//                     >
//                       Logout
//                     </button>

//                   </div>
//                 )}

//               </div>
//             ) : (
//               <Link to="/login" className="flex flex-col items-center">
//                 <FaUser />
//                 <span>Sign in</span>
//               </Link>
//             )}

//             {/* WISHLIST */}
//             <div className="flex flex-col items-center relative cursor-pointer">
//               <FaHeart />
//               <span>Wishlist</span>
//             </div>

//             {/* CART */}
//             <Link to="/cart" className="flex flex-col items-center relative">
//               <FaShoppingCart />
//               <span>Cart</span>

//               {cartCount > 0 && (
//                 <span className="absolute -top-2 -right-3 bg-red-500 text-white text-xs px-1 rounded-full">
//                   {cartCount}
//                 </span>
//               )}
//             </Link>

//           </div>

//         </div>

//       </header>

//       {/* 🔥 MOBILE HEADER */}
//       <div className="md:hidden fixed top-0 w-full bg-white z-50 shadow flex items-center justify-between px-4 py-3">

//         <img src={logo} alt="logo" className="h-8" />

//         <div className="flex items-center gap-4 text-lg">

//           {user ? (
//             <Link to="/account/profile">
//               <FaUser />
//             </Link>
//           ) : (
//             <Link to="/login">
//               <FaUser />
//             </Link>
//           )}

//           <Link to="/cart" className="relative">
//             <FaShoppingCart />
//             {cartCount > 0 && (
//               <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-1 rounded-full">
//                 {cartCount}
//               </span>
//             )}
//           </Link>

//           <FaBars onClick={() => setMenuOpen(true)} />

//         </div>

//       </div>

//       {/* 🔥 MOBILE DRAWER */}
//       <div className={`fixed top-0 left-0 h-full w-[85%] bg-white z-50 shadow-lg transition-transform ${menuOpen ? "translate-x-0" : "-translate-x-full"}`}>

//         <div className="p-4 border-b flex justify-between">
//           <h2 className="font-bold text-lg">Menu</h2>
//           <button onClick={() => setMenuOpen(false)}>✕</button>
//         </div>

//         <div className="px-4 space-y-4 text-sm">

//           <Link to="/">Home</Link>

//           {user ? (
//             <>
//               <Link to="/account/profile">My Account</Link>
//               <Link to="/account/orders">Orders</Link>

//               {user.role === "ADMIN" && (
//                 <Link to="/admin-panel/dashboard">Admin Panel</Link>
//               )}

//               <button onClick={handleLogout} className="text-red-500">
//                 Logout
//               </button>
//             </>
//           ) : (
//             <Link to="/login">Login</Link>
//           )}

//         </div>

//       </div>

//       {/* OVERLAY */}
//       {menuOpen && (
//         <div
//           onClick={() => setMenuOpen(false)}
//           className="fixed inset-0 bg-black/40 z-40"
//         />
//       )}

//     </>
//   );
// };

// export default Header;
import React, { useState, useEffect } from "react";
import {
  FaShoppingCart,
  FaUser,
  FaBars,
} from "react-icons/fa";
import { GrSearch } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import logo from "../assest/products/extra/logo.jpeg";
import { logoutUser } from "../store/userSlice";
import { motion } from "framer-motion";

const Header = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cartCount = useSelector((state) => state.cart.cartCount);
  const user = useSelector((state) => state.user.user);

  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [search, setSearch] = useState("");

  // 🔥 TYPING PLACEHOLDER
  const texts = ["Search laptops...", "Search gaming laptop...", "Search refurbished laptops..."];
  const [placeholder, setPlaceholder] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let i = 0;

    const interval = setInterval(() => {
      setPlaceholder(texts[index].slice(0, i));
      i++;

      if (i > texts[index].length) {
        clearInterval(interval);

        setTimeout(() => {
          setIndex((prev) => (prev + 1) % texts.length);
        }, 1500);
      }

    }, 60);

    return () => clearInterval(interval);

  }, [index]);

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/search?q=${search}`);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    setDropdown(false);
    navigate("/login");
  };

  return (
    <>
      {/* 🔥 DESKTOP HEADER */}
      <header className="hidden md:block w-full bg-gradient-to-r from-white to-gray-50 shadow fixed top-0 z-50">

        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

          {/* 🔥 LOGO */}
          <Link to="/">
            <motion.img
              whileHover={{ scale: 1.1 }}
              src={logo}
              alt="logo"
              className="h-11 cursor-pointer"
            />
          </Link>

          {/* 🔥 SEARCH */}
          <form
            onSubmit={handleSearch}
            className="flex items-center bg-white border-2 border-gray-200 rounded-full overflow-hidden w-[500px] shadow-sm"
          >
            <input
              type="text"
              placeholder={placeholder}
              className="flex-1 px-4 py-2 outline-none text-sm"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <button className="bg-gradient-to-r from-red-500 to-red-400 text-white px-5 py-2">
              <GrSearch />
            </button>
          </form>

          {/* 🔥 RIGHT */}
          <div className="flex items-center gap-6 text-sm">

            {/* USER */}
            {user ? (
              <div className="relative">

                <div
                  onClick={() => setDropdown(!dropdown)}
                  className="flex flex-col items-center cursor-pointer"
                >
                  <div className="w-9 h-9 rounded-full bg-black text-white flex items-center justify-center text-sm">
                    {user.name?.charAt(0)}
                  </div>

                  <span className="text-xs mt-1">
                    {user.name?.split(" ")[0]}
                  </span>
                </div>

                {/* DROPDOWN */}
                {dropdown && (
                  <div className="absolute right-0 mt-2 w-44 bg-white shadow-xl rounded-xl p-2 z-50">

                    <Link
                      to="/account/profile"
                      onClick={() => setDropdown(false)}
                      className="block px-3 py-2 hover:bg-gray-100 rounded"
                    >
                      My Account
                    </Link>

                    <Link
                      to="/account/orders"
                      onClick={() => setDropdown(false)}
                      className="block px-3 py-2 hover:bg-gray-100 rounded"
                    >
                      Orders
                    </Link>

                    {user.role === "ADMIN" && (
                      <Link
                        to="/admin-panel/dashboard"
                        onClick={() => setDropdown(false)}
                        className="block px-3 py-2 text-blue-600 hover:bg-gray-100 rounded"
                      >
                        Admin Panel
                      </Link>
                    )}

                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-3 py-2 hover:bg-gray-100 text-red-500 rounded"
                    >
                      Logout
                    </button>

                  </div>
                )}

              </div>
            ) : (
              <Link to="/login" className="flex flex-col items-center">
                <FaUser />
                <span className="text-xs">Sign in</span>
              </Link>
            )}

            {/* CART */}
            <Link to="/cart" className="relative flex flex-col items-center">
              <FaShoppingCart />

              <span className="text-xs">Cart</span>

              {cartCount > 0 && (
                <span className="absolute -top-2 -right-3 bg-red-500 text-white text-xs px-1 rounded-full">
                  {cartCount}
                </span>
              )}
            </Link>

          </div>

        </div>

      </header>

      {/* 🔥 MOBILE HEADER */}
      <div className="md:hidden fixed top-0 w-full bg-white z-50 shadow flex items-center justify-between px-4 py-3">

        <Link to="/">
          <img src={logo} alt="logo" className="h-9" />
        </Link>

        <div className="flex items-center gap-4 text-lg">

          <Link to={user ? "/account/profile" : "/login"}>
            <FaUser />
          </Link>

          <Link to="/cart" className="relative">
            <FaShoppingCart />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-1 rounded-full">
                {cartCount}
              </span>
            )}
          </Link>

          <FaBars onClick={() => setMenuOpen(true)} />

        </div>

      </div>

      {/* 🔥 MOBILE DRAWER */}
      <div className={`fixed top-0 left-0 h-full w-[85%] bg-white z-50 shadow-lg transition-transform ${menuOpen ? "translate-x-0" : "-translate-x-full"}`}>

        <div className="p-4 border-b flex justify-between">
          <h2 className="font-bold text-lg">Menu</h2>
          <button onClick={() => setMenuOpen(false)}>✕</button>
        </div>

        <div className="px-4 space-y-4 text-sm">

          <Link to="/" onClick={()=>setMenuOpen(false)}>Home</Link>

          {user ? (
            <>
              <Link to="/account/profile" onClick={()=>setMenuOpen(false)}>My Account</Link>
              <Link to="/account/orders" onClick={()=>setMenuOpen(false)}>Orders</Link>

              {user.role === "ADMIN" && (
                <Link to="/admin-panel/dashboard" onClick={()=>setMenuOpen(false)}>Admin Panel</Link>
              )}

              <button onClick={handleLogout} className="text-red-500">
                Logout
              </button>
            </>
          ) : (
            <Link to="/login" onClick={()=>setMenuOpen(false)}>Login</Link>
          )}

        </div>

      </div>

      {/* OVERLAY */}
      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          className="fixed inset-0 bg-black/40 z-40"
        />
      )}

    </>
  );
};

export default Header;